const months = [
    {
      code: '1',
      text: 'Enero',
    },
    {
      code: '2',
      text: 'Febrero',
    },
    {
      code: '3',
      text: 'Marzo',
    },
    {
      code: '4',
      text: 'Abril',
    },
    {
      code: '5',
      text: 'Mayo',
    },
    {
      code: '6',
      text: 'Junio',
    },
    {
      code: '7',
      text: 'Julio',
    },
    {
      code: '8',
      text: 'Agosto',
    },
    {
      code: '9',
      text: 'Septiembre',
    },
    {
      code: '10',
      text: 'Octubre',
    },
    {
      code: '11',
      text: 'Noviembre',
    },
    {
      code: '12',
      text: 'Diciembre',
    },
];

const now = new Date();

const years = Array(16).fill().map((data, index) => ({ 
	code: now.getFullYear() + index,
	text: now.getFullYear() + index,
})) 

export default {
	communes: [],
	months,
	years,
};